module.exports = __webpack_public_path__ + "images/f23855e6bd94649bcfad4e8e1f9d17efform.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/form.png
// module id = rfL+
// module chunks = 0